//var baseURL = 'http://localhost:8080/';
var baseURL = 'https://api.grafiame.com.br/';

export default baseURL;